import FormHeadingWithIcon from "../../atoms/forms/FormHeadingWithIcon";
import StepsBar from "../StepsBar";

type Props = {
  icon: string;
  heading: string;
  subHeading: string;
  currentStep: number;
  totalSteps: number;
  headingAdditionalClasses?: string;
  subHeadingAdditionalClasses?: string;
};

function FormHeader({
  icon,
  heading,
  subHeading,
  headingAdditionalClasses,
  subHeadingAdditionalClasses,
  currentStep,
  totalSteps,
}: Props) {
  return (
    <div className="flex flex-col justify-start gap-y-6 font-sora text-white">
      <StepsBar currentStep={currentStep} totalSteps={totalSteps} />
      <div>
        <FormHeadingWithIcon icon={icon} heading={heading} headingAdditionalClasses={headingAdditionalClasses} />
        <span
          className={`my-2 mt-2 font-satoshi text-lg font-450 ${subHeadingAdditionalClasses}`}
          dangerouslySetInnerHTML={{ __html: subHeading }}
        />
      </div>
    </div>
  );
}
export default FormHeader;

FormHeader.defaultProps = {
  headingAdditionalClasses: "",
  subHeadingAdditionalClasses: "",
};
